import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";

export interface StoreInvestmentTransactionPayload {
  type: "buy" | "sell";
  quantity?: number | null;
  unitPrice?: number | null;
  totalValue: number | null;
  currencyUuid: string;
  note?: string | null;
  completedAt?: string | null;
  fileId?: number | null;
  clientId?: number | null;
}

export const useStoreInvestmentTransaction = (
  options?: UseMutationOptions<
    any,
    Error,
    { investmentUuid: string; data: StoreInvestmentTransactionPayload }
  >,
) => {
  return useMutation({
    ...options,
    mutationKey: ["storeInvestmentTransaction"],
    mutationFn: async ({ investmentUuid, data }) => {
      return axiosInstance
        .post(`/investments/${investmentUuid}/transactions`, data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie transakcji...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "store-investment-transaction",
      });
      if (options?.onMutate) {
        return options.onMutate(variables) as any;
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Transakcja dodana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "store-investment-transaction",
      });
      queryClient.invalidateQueries({
        queryKey: ["investmentTransactions", variables.investmentUuid],
      });
      queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      queryClient.invalidateQueries({ queryKey: ["investment-types"] });
      queryClient.invalidateQueries({ queryKey: ["investments/summary"] });
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas dodawania transakcji.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "store-investment-transaction",
      });
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
